module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_header_fukidashi-e303c75e4cd956e731afdcfc5f81bb07.svg";